module.exports = __webpack_public_path__ + "img/8corazon.1e9e59b0.png";